import actionTypes from '../../actionTypes'
import initial from '../../initial'

const permission = (state = initial.permission, action) => {
  switch (action.type) {
  case actionTypes.SET_SHOW_PREMIUM_ACTIONS:
    return { ...state, showPremiumActions: action.payload }
  default:
    return state
  }
}

export default permission
